export const LoggedInStateSessionKey = "state.loggedIn";
export const IsAdminSessionKey = "state.isAdmin";
export const advisorEmailLocalStorageKey = "farther.advisor.email";
export const clientFiltersStorageKey = "farther.advisor.clientFilters";
export const taskFiltersStorageKey = "farther.advisor.taskFilters";
export const taskActivityOrderStorageKey = "farther.advisor.taskActivityOrder";
export const householdsViewStorageKey = "farther.advisor.householdsView";
